import { useState } from 'react';
import type { FormEvent } from 'react';
import { useAuth } from '../app/Auth';
import { ErrorNote, SecretField } from '../app/ui';
import { nexusHostLabel } from '../lib/config';

export function SignIn() {
  const { signIn, bootError } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true); setError(null);
    try { await signIn(email, password); }
    catch (err) { setError(err instanceof Error ? err.message : String(err)); }
    finally { setBusy(false); setPassword(''); }
  }

  return (
    <div className="center-screen">
      <form className="card signin" onSubmit={submit}>
        <h1>Helm</h1>
        <p className="muted">Sign in to {nexusHostLabel()}</p>
        <label htmlFor="email">Email</label>
        <input id="email" type="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} autoFocus />
        <label htmlFor="pw">Password</label>
        <SecretField id="pw" value={password} onChange={setPassword} autoComplete="current-password" />
        <ErrorNote text={error ?? bootError} />
        <button className="btn primary" type="submit" disabled={busy || !email || !password}>{busy ? 'Signing in…' : 'Sign in'}</button>
        <p className="muted small">Password sign-in only for now. Apple and Google sign-in work in the Mac and iPhone apps once the account is connected; the web console will get them next.</p>
      </form>
    </div>
  );
}
